var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"disabled":_vm.textBoxDisabled,"prepend-icon":"mdi-calendar-blank","label":_vm.label,"items":_vm.years},model:{value:(_vm.computedDate),callback:function ($$v) {_vm.computedDate=$$v},expression:"computedDate"}})
}
var staticRenderFns = []

export { render, staticRenderFns }